"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-253bad50"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "border-bottom" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex-justify-between" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "メイン業務")
], -1 /* HOISTED */));
const _hoisted_3 = {
    key: 0,
    class: "d-flex flex-wrap mb-1"
};
const _hoisted_4 = { class: "role-section-chip-wrapper" };
const _hoisted_5 = ["href"];
const _hoisted_6 = { class: "text-ellipsis" };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("small", { class: "oplus-gray-text" }, "メイン業務がありません", -1 /* HOISTED */));
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = { class: "m-top" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex-justify-between" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "サブ業務")
], -1 /* HOISTED */));
const _hoisted_12 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "text-ellipsis" };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("small", { class: "oplus-gray-text" }, "サブ業務がありません", -1 /* HOISTED */));
const _hoisted_17 = [
    _hoisted_16
];
const vue_3 = require("vue");
const models_1 = require("../../js/models");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRelationList',
    setup(__props) {
        const subRoles = (0, vue_3.inject)("subRoles");
        const mainRole = (0, vue_3.inject)("mainRole");
        const activeUserData = (0, vue_3.inject)('activeUserData');
        function roleStyle(role) {
            return {
                backgroundColor: `#${role.color ? role.color : models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: !role.color || role.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT ? '' : '#fff'
            };
        }
        function roleLabel(role) {
            if (!role.from && !role.to) {
                return role.name;
            }
            return `${role.name} ${role.from} ~ ${role.to}`;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    _hoisted_2,
                    ((0, vue_2.unref)(mainRole))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                (0, vue_2.createElementVNode)("a", {
                                    class: "chip c-hand role-section-slot-chip d-flex sub-role-chip",
                                    style: (0, vue_2.normalizeStyle)(roleStyle((0, vue_2.unref)(mainRole))),
                                    href: `/dashboard/${(0, vue_2.unref)(activeUserData)?.userId}/role/${(0, vue_2.unref)(mainRole).id}?c=${(0, vue_2.unref)(activeUserData)?.branchId}`
                                }, [
                                    (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(roleLabel((0, vue_2.unref)(mainRole))), 1 /* TEXT */)
                                ], 12 /* STYLE, PROPS */, _hoisted_5)
                            ])
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, _hoisted_9))
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_10, [
                    _hoisted_11,
                    ((0, vue_2.unref)(subRoles)?.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(subRoles), (subRole) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    class: "role-section-chip-wrapper",
                                    key: subRole.id
                                }, [
                                    (0, vue_2.createElementVNode)("a", {
                                        class: "chip c-hand role-section-slot-chip d-flex sub-role-chip",
                                        style: (0, vue_2.normalizeStyle)(roleStyle(subRole)),
                                        href: `/dashboard/${(0, vue_2.unref)(activeUserData)?.userId}/role/${subRole.id}?c=${(0, vue_2.unref)(activeUserData)?.branchId}`
                                    }, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)(roleLabel(subRole)), 1 /* TEXT */)
                                    ], 12 /* STYLE, PROPS */, _hoisted_13)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, _hoisted_17))
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
